import Vue from 'vue';

export const adminService = {
  async fetchEmailLogs(params) {
    return Vue.axios
      .get(`/admin/email-log`, {
        params: {
          ...params
        }
      })
      .then(response => response.data);
  },

  async fetchEmailLogRecordCount() {
    return Vue.axios.get(`/admin/email-log-count`).then(response => response.data);
  }
};
